import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeySearchComponent } from './components/key-search/key-search.component';
import { FormsModule } from '@angular/forms';
import { MaterialComponentsModule } from '../material/material-components.module';
import { TableDataLoaderComponent } from './components/table-data-loader/table-data-loader.component';
import { PropertySearchComponent } from './components/property-search/property-search.component';
import { BorrowerSearchComponent } from './components/borrower-search/borrower-search.component';
import { HoverDropDownDirective } from './directives/hover-drop-down.directive';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { OrderByDatePipe } from './pipes/order-by-date.pipe';
import { FileDeleteConfirmComponent } from './components/file-delete-confirm/file-delete-confirm.component';
import { CheckoutConfirmComponent } from './components/checkout-confirm/checkout-confirm.component';
import { CommonLoaderComponent } from './components/common-loader/common-loader.component';
import { StripePaymentSettingsComponent } from './components/stripe-payment-settings/stripe-payment-settings.component';
import { CustomBorrowerSearchComponent } from './components/custom-borrower-search/custom-borrower-search.component';
import { CustomBorrowerComponent } from './components/custom-borrower/custom-borrower.component';
import { QrCodeScannerComponent } from './components/qr-code-scanner/qr-code-scanner.component';
import { AddBookingComponent } from './components/add-booking/add-booking.component';

import { RouterModule } from '@angular/router';
import { CheckinKeyForBorrowerComponent } from './components/checkin-key-for-borrower/checkin-key-for-borrower.component';
import { KeyIssueReportComponent } from './components/key-issue-report/key-issue-report.component';
import { BookingDetailComponent } from './components/booking-detail/booking-detail.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RfidScannerComponent } from './components/rfid-scanner/rfid-scanner.component';


@NgModule({
  declarations: [
    KeySearchComponent,
    TableDataLoaderComponent,
    PropertySearchComponent,
    BorrowerSearchComponent,
    HoverDropDownDirective,
    DateFormatPipe,
    OrderByDatePipe,
    FileDeleteConfirmComponent,
    CheckoutConfirmComponent,
    CommonLoaderComponent,
    StripePaymentSettingsComponent,
    CustomBorrowerSearchComponent,
    CustomBorrowerComponent,
    QrCodeScannerComponent,
    AddBookingComponent,
    CheckinKeyForBorrowerComponent,
    KeyIssueReportComponent,
    BookingDetailComponent,
    RfidScannerComponent
  ],
  imports: [CommonModule, FormsModule, MaterialComponentsModule, RouterModule,ReactiveFormsModule],
  exports: [
    KeySearchComponent,
    TableDataLoaderComponent,
    PropertySearchComponent,
    BorrowerSearchComponent,
    HoverDropDownDirective,
    DateFormatPipe,
    OrderByDatePipe,
    CommonLoaderComponent,
    StripePaymentSettingsComponent,
    CustomBorrowerSearchComponent,
    CustomBorrowerComponent,
    QrCodeScannerComponent,
    AddBookingComponent,
    BookingDetailComponent,
    RfidScannerComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
